import { SupportedLanguageSchema } from '@geartracker/types';

import { createZodDto } from './zod';

import { z } from 'zod';

const billingClientSchema = z.object({
  name: z.string().min(1).max(200),
  contactName: z.string().max(200).optional(),
  email: z.email(),
  country: z.string().length(2),
  addressLine1: z.string().min(1).max(255),
  addressLine2: z.string().max(255).optional(),
  city: z.string().min(1).max(200),
  state: z.string().max(100).optional(),
  postalCode: z.string().min(1).max(20),
  language: SupportedLanguageSchema,
  currency: z.string().length(3),
  vatNumber: z.string().max(50).optional(),
  notes: z.string().max(2000).optional(),
});

export class CreateBillingClientDto extends createZodDto(
  billingClientSchema.refine(
    (data) => data.country !== 'US' || Boolean(data.state?.trim()),
    { message: 'state is required for US clients', path: ['state'] },
  ),
) {}

export class UpdateBillingClientDto extends createZodDto(
  billingClientSchema.partial().extend({
    contactName: z.string().max(200).nullable().optional(),
    addressLine2: z.string().max(255).nullable().optional(),
    vatNumber: z.string().max(50).nullable().optional(),
    notes: z.string().max(2000).nullable().optional(),
  }),
) {}

const billingInvoiceLineItemSchema = z.object({
  description: z.string().min(1).max(500),
  quantity: z.number().int().positive().default(1),
  unitAmount: z.number().int().positive(), // cents
});

const createBillingInvoiceSchema = z.object({
  // Generated once when the form opens and reused for retries. This makes the
  // operation (including its Stripe calls) safe to replay after a timeout.
  idempotencyKey: z.uuid(),
  daysUntilDue: z.number().int().min(0).max(365).default(30),
  lineItems: z.array(billingInvoiceLineItemSchema).min(1),
});

export class CreateBillingInvoiceDto extends createZodDto(
  createBillingInvoiceSchema,
) {}
